import React from 'react';
import ConditionRow from '../ConditionRow';

// List of filter conditions in the shape the server understands:
// { field, op, value | values | min, max, target }.
export default function ConditionsControl({ label, fields, joins, value = [], onChange }) {
  const update = (index, condition) => onChange(value.map((c, i) => (i === index ? condition : c)));
  const remove = (index) => onChange(value.filter((_, i) => i !== index));
  const add = () => onChange([...value, { field: '', op: 'eq', values: [] }]);

  return (
    <div className="form-field">
      <span className="form-label">{label}</span>
      {value.length === 0 && <p className="form-hint">No conditions — all rows pass.</p>}
      {value.map((condition, index) => (
        <ConditionRow
          key={index}
          fields={fields}
          joins={joins}
          condition={condition}
          logic={condition.logic}
          onChange={(next) => update(index, next)}
          onLogicChange={index > 0 ? (logic) => update(index, { ...condition, logic }) : undefined}
          onRemove={() => remove(index)}
        />
      ))}
      <button type="button" className="btn btn-secondary" onClick={add}>
        + Condition
      </button>
    </div>
  );
}
